import { render, staticRenderFns } from "./FacebookCampaignDetails.vue?vue&type=template&id=6627bfb4"
import script from "./FacebookCampaignDetails.vue?vue&type=script&lang=ts"
export * from "./FacebookCampaignDetails.vue?vue&type=script&lang=ts"
import style0 from "./FacebookCampaignDetails.vue?vue&type=style&index=0&id=6627bfb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports